import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../../styles'
import RemoveItem from '../../../../../Assets/Images/icons/removeItem'

const ChatParticipantsFormItem = ({ classes, name, onItemDelete }) => {
  return (
    <article className={classes.itemWrapper}>
      <span className={classes.title}>{name}</span>
      <i className={classes.icon} onClick={onItemDelete}>
        <RemoveItem />
      </i>
    </article>
  )
}

ChatParticipantsFormItem.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatParticipantsFormItem)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatParticipantsForm/blocks/ChatParticipantsFormItem/ChatParticipantsFormItem.js